// extracted by mini-css-extract-plugin
module.exports = {"modalWrapper":"CustomModal_modalWrapper__KWxYN","contentWrapper":"CustomModal_contentWrapper__Bt3Mz","pictureWrapper":"CustomModal_pictureWrapper___qHgh"};